<mat-sidenav-container [@.disabled]="true">
  <mat-sidenav
    [autoFocus]="false"
    [mode]="sidebarMode$ | async"
    [opened]="isSidebarOpen$ | async"
    class="mat-elevation-z1"
    [@.disabled]="true"
    (closed)="onClose()"
  >
    <app-location-sidebar></app-location-sidebar>
  </mat-sidenav>
  <mat-sidenav-content [@.disabled]="true">
    <router-outlet (activate)="onActivate()"> </router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
